import $http from '$http';
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from 'utils';
import {
  GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
  methods: {
    // 查看/修改获取单条
    getList(orderId) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        OrderId: orderId
      };
      this.GoodsListNum = []
      this.ListData = []
      $http.get("api/MeetOrder/GetMeetLinkOrderByIdEx", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        util.doResult(this, res, () => {

          this.form = util.filterAndSetData(this.form, Data) //过滤数据
          this.form.VirtualList = []

          for (let i = 0; i < Data.GiftList.length; i++) {
            if (Data.GiftList[i].ProBrand === 1) {
              // 联帮在线
              if (this.form.SendLessonReason == 7) {
                // oa
                if (Data.GiftList[i].ProId == 759) {
                  this.form.VirtualList.push({
                    "ProId": Data.GiftList[i].ProId,
                    "ProNum": Data.GiftList[i].ProNum,
                    "ProBrand": Data.GiftList[i].ProBrand,
                    "minNum": 4,
                    "maxNum": Infinity,
                    "LessonTypes": [{
                      id: 759,
                      name: "D体验课"
                    }, {
                      id: 752,
                      name: "公开课"
                    }, {
                      id: 757,
                      name: "正式课"
                    }]
                  })
                } else if (Data.GiftList[i].ProId == 757) {
                  this.form.VirtualList.push({
                    "ProId": Data.GiftList[i].ProId,
                    "ProNum": Data.GiftList[i].ProNum,
                    "ProBrand": Data.GiftList[i].ProBrand,
                    "minNum": 16,
                    "maxNum": 32,
                    "LessonTypes": [{
                      id: 759,
                      name: "D体验课"
                    }, {
                      id: 752,
                      name: "公开课"
                    }, {
                      id: 757,
                      name: "正式课"
                    }]
                  })
                } else {
                  this.form.VirtualList.push({
                    "ProId": Data.GiftList[i].ProId,
                    "ProNum": Data.GiftList[i].ProNum,
                    "ProBrand": Data.GiftList[i].ProBrand,
                    "minNum": 1,
                    "maxNum": Infinity,
                    "LessonTypes": [{
                      id: 759,
                      name: "D体验课"
                    }, {
                      id: 752,
                      name: "公开课"
                    }, {
                      id: 757,
                      name: "正式课"
                    }]
                  })
                }
              } else if (this.form.SendLessonReason == 2) {
                this.form.VirtualList.push({
                  "ProId": Data.GiftList[i].ProId,
                  "ProNum": Data.GiftList[i].ProNum,
                  "ProBrand": Data.GiftList[i].ProBrand,
                  "minNum": 1,
                  "maxNum": this.maxNum,
                  "LessonTypes": [{
                    id: 752,
                    name: "公开课"
                  }, {
                    id: 756,
                    name: "中教课"
                  }]
                })
              } else if (this.form.SendLessonReason == 1 || this.form.SendLessonReason == 6) {
                this.form.VirtualList.push({
                  "ProId": Data.GiftList[i].ProId,
                  "ProNum": Data.GiftList[i].ProNum,
                  "ProBrand": Data.GiftList[i].ProBrand,
                  "minNum": 1,
                  "maxNum": this.maxNum,
                  "LessonTypes": [{
                    id: 759,
                    name: "D体验课"
                  }, {
                    id: 752,
                    name: "公开课"
                  }, {
                    id: 757,
                    name: "正式课"
                  }]
                })

              } else if (this.form.SendLessonReason > 2 && this.form.SendLessonReason !== 7) {
                this.form.VirtualList.push({
                  "ProId": Data.GiftList[i].ProId,
                  "ProNum": Data.GiftList[i].ProNum,
                  "ProBrand": Data.GiftList[i].ProBrand,
                  "minNum": 1,
                  "maxNum": this.maxNum,
                  "LessonTypes": [{
                    id: 754,
                    name: "寒暑班"
                  }]
                })
              }
            } else if (Data.GiftList[i].ProBrand > 1) {
              // hi幼教  智趣屋
              if (this.form.SendLessonReason == 7) {
                // oa
                if (Data.GiftList[i].ProId == 759) {
                  this.form.VirtualList.push({
                    "ProId": Data.GiftList[i].ProId,
                    "ProNum": Data.GiftList[i].ProNum,
                    "ProBrand": Data.GiftList[i].ProBrand,
                    "minNum": 4,
                    "maxNum": Infinity,
                    "LessonTypes": [{
                      id: 750,
                      name: "体验课赠课"
                    }, {
                      id: 759,
                      name: "D体验课"
                    }, {
                      id: 752,
                      name: "公开课"
                    }, {
                      id: 757,
                      name: "正式课"
                    }]
                  })
                } else if (Data.GiftList[i].ProId == 757) {
                  this.form.VirtualList.push({
                    "ProId": Data.GiftList[i].ProId,
                    "ProNum": Data.GiftList[i].ProNum,
                    "ProBrand": Data.GiftList[i].ProBrand,
                    "minNum": 16,
                    "maxNum": 32,
                    "LessonTypes": [{
                      id: 750,
                      name: "体验课赠课"
                    }, {
                      id: 759,
                      name: "D体验课"
                    }, {
                      id: 752,
                      name: "公开课"
                    }, {
                      id: 757,
                      name: "正式课"
                    }]
                  })
                } else {
                  this.form.VirtualList.push({
                    "ProId": Data.GiftList[i].ProId,
                    "ProNum": Data.GiftList[i].ProNum,
                    "ProBrand": Data.GiftList[i].ProBrand,
                    "minNum": 1,
                    "maxNum": Infinity,
                    "LessonTypes": [{
                      id: 750,
                      name: "体验课赠课"
                    }, {
                      id: 759,
                      name: "D体验课"
                    }, {
                      id: 752,
                      name: "公开课"
                    }, {
                      id: 757,
                      name: "正式课"
                    }]
                  })
                }
              } else if (this.form.SendLessonReason == 2) {
                this.form.VirtualList.push({
                  "ProId": Data.GiftList[i].ProId,
                  "ProNum": Data.GiftList[i].ProNum,
                  "ProBrand": Data.GiftList[i].ProBrand,
                  "minNum": 1,
                  "maxNum": this.maxNum,
                  "LessonTypes": [{
                    id: 752,
                    name: "公开课"
                  }, {
                    id: 756,
                    name: "中教课"
                  }]
                })
              } else if (this.form.SendLessonReason == 1 || this.form.SendLessonReason == 6) {
                this.form.VirtualList.push({
                  "ProId": Data.GiftList[i].ProId,
                  "ProNum": Data.GiftList[i].ProNum,
                  "ProBrand": Data.GiftList[i].ProBrand,
                  "minNum": 1,
                  "maxNum": this.maxNum,
                  "LessonTypes": [{
                    id: 750,
                    name: "体验课赠课"
                  }, {
                    id: 759,
                    name: "D体验课"
                  }]
                })

              } else if (this.form.SendLessonReason > 2 && this.form.SendLessonReason !== 7) {
                this.form.VirtualList.push({
                  "ProId": Data.GiftList[i].ProId,
                  "ProNum": Data.GiftList[i].ProNum,
                  "ProBrand": Data.GiftList[i].ProBrand,
                  "minNum": 1,
                  "maxNum": this.maxNum,
                  "LessonTypes": [{
                    id: 754,
                    name: "寒暑班"
                  }]
                })
              }
            }


          }

          // for (let i = 0; i < Data.GiftList.length; i++) {
          //   this.form.VirtualList.push({
          //     "ProId": Data.GiftList[i].ProId,
          //     "ProNum": Data.GiftList[i].ProNum,
          //     "ProBrand": Data.GiftList[i].ProBrand,
          //     "minNum": 1,
          //     "maxNum": this.maxNum
          //   })

          // }

          this.storageData = Data.SendLessonReason
          this.ClassNum = this.form.ClassNum
            // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
          this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
            //园所名称，园长姓名及园长电话
          this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo

        });
      });
    },

    //送课新增POST /api/MeetOrder/SendLessonOrderAdd
    SendLessonOrderAdd() {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
      };
      this.loading = true;
      $http.post("api/MeetOrder/SendLessonOrderAdd", Object.assign({}, params, this.form)).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          });
          this.$emit('getTableList')
          this.AddDialogVisible = false
        });
      });
    },

    //POST /api/MeetOrder/SendLessonOrderUpdate
    SendLessonOrderUpdate() {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,

      };
      this.loading = true;
      $http.post("api/MeetOrder/SendLessonOrderUpdate", Object.assign({}, params, this.form)).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          });
          this.$emit('getTableList')
          this.AddDialogVisible = false
        });
      });
    },


  }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addSendLessonDialog/services.js